import { PageHeader } from "../components/PageHeader";
import { SolarCalculator } from "../components/SolarCalculator";
import { CTASection } from "../components/CTASection";

export default function Calculator() {
  return (
    <>
      <PageHeader
        eyebrow="GES Hesaplama Aracı"
        titleLines={["Cihazlarınızı seçin,", "tasarrufu görün."]}
        description="Evinizdeki elektrikli cihazları, adet ve günlük çalışma sürelerini girin; önerilen sistem gücü, panel sayısı, yıllık tasarruf, geri dönüş süresi ve çevresel etkiyi anında hesaplayalım."
      />
      <section className="relative bg-[#0A0A0A] pb-24 sm:pb-32">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <SolarCalculator />
        </div>
      </section>
      <CTASection />
    </>
  );
}
